import { render, staticRenderFns } from "./FilterSortTab.vue?vue&type=template&id=51aa231e&scoped=true&"
import script from "./FilterSortTab.vue?vue&type=script&lang=js&"
export * from "./FilterSortTab.vue?vue&type=script&lang=js&"
import style0 from "./FilterSortTab.vue?vue&type=style&index=0&id=51aa231e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa231e",
  null
  
)

export default component.exports